
import generateAzureBlobPath from './generateAzureBlobPath';

function generateFileUploadDetails(source, formInfo){
    const formData = new FormData();
    if(source?.includes('Firmware')){
        // Version prefix keeps the same file uploadable for multiple software versions
        const blobName = `${formInfo.majorVersion}_${formInfo.fileName}`;
        formData.append('file', formInfo.file, blobName)
        formData.append('fileName', blobName)
        formData.append('folderStructure', generateAzureBlobPath(source, { ...formInfo, fileName: blobName }))
        return formData
    }
    formData.append('file', formInfo.file)
    formData.append('fileName', formInfo.fileName)
    formData.append('folderStructure', generateAzureBlobPath(source, formInfo))

    return formData
}

export default generateFileUploadDetails;